import { useParams, useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import StatPersonList from '@/components/dashboard/StatPersonList'

const STAT_TITLES = {
  inside_now:   'Сейчас внутри',
  absent_today: 'Не явились',
  late_total:   'Опоздали',
  on_time:      'Вовремя',
  students_in:  'Студентов сегодня',
  employees_in: 'Сотрудников сегодня',
  total_in:     'Всего вошли',
  total_out:    'Всего вышли',
  no_schedule:  'Без расписания',
}

export default function DashboardStatPage() {
  const { stat } = useParams()
  const navigate = useNavigate()
  const title = STAT_TITLES[stat] || 'Список'

  return (
    <div className="min-h-screen bg-[#F8F9FB] flex flex-col">
      {/* Header */}
      <header className="sticky top-0 z-10 bg-white border-b border-slate-100 px-4 py-3.5 flex items-center gap-3 shadow-sm">
        <button
          onClick={() => navigate(-1)}
          className="p-2 rounded-xl hover:bg-slate-100 text-slate-600 transition-colors"
        >
          <ArrowLeft size={20} />
        </button>
        <h1 className="text-base font-black text-slate-900 tracking-tight">{title}</h1>
      </header>

      {/* Content */}
      <div className="flex-1 p-4 overflow-hidden">
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 h-[calc(100vh-8rem)] flex flex-col">
          <StatPersonList stat={stat} title={title} />
        </div>
      </div>
    </div>
  )
}
